module.exports = __webpack_public_path__ + "static/media/Kent Kitchen .f2af30f1.JPG";